import { type FailureResponse, type JobStatus } from '@blaze-shared/api-contracts-domain';

import { JOB_FINISH_STATUSES } from './models/job-finish-statuses';

export function isJobFinished(status: JobStatus): boolean {
  return JOB_FINISH_STATUSES.has(status);
}

export function generateErrorMessageFromResponse(result?: FailureResponse): string {
  const errorSections = [
    ['Column', result?.columnName],
    ['Row Number', result?.rowNumber],
    ['Error', result?.errorMessage],
  ];
  return (
    errorSections
      .filter(([_, errorValue]) => !!errorValue)
      .map(([errorSection, errorValue]) => `${errorSection}: ${errorValue}`)
      .join(', ') ?? 'There was an error when processing the task'
  );
}
